/* SS 18.09.2026 - lazy mobilmeny. Skuffens innhold rendres ikke i sidens HTML (snippets/kalis-drawer-menu.liquid); dette skriptet henter det
   fra Section Rendering API (/search?q=__ss_drawer__&sections=header -> header.liquid rendrer bare skuffen) naar siden er ferdig lastet og
   nettleseren er ledig, eller straks brukeren tar paa menyknappen. Impulse-kollapsene bindes med theme.collapsibles.init(scope). */
(function () {
  var box = document.querySelector('.ss-drawer-lazy'); if (!box) return;
  var src = box.getAttribute('data-ss-drawer-src'); var state = 0; /* 0 = ikke startet, 1 = laster, 2 = ferdig */
  function load() {
    if (state) return; state = 1;
    fetch(src, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (j) {
        var tmp = document.createElement('div'); tmp.innerHTML = j.header || '';
        var inner = tmp.querySelector('#NavDrawer .drawer__scrollable'); if (!inner) throw new Error('no drawer');
        var target = box.closest('.drawer__scrollable') || box.parentNode;
        target.innerHTML = inner.innerHTML; state = 2;
        if (window.theme && theme.collapsibles && theme.collapsibles.init) theme.collapsibles.init(target);
        document.dispatchEvent(new CustomEvent('ss:drawer-loaded'));
      })
      .catch(function () { state = 0; });
  }
  ['pointerdown', 'touchstart', 'mouseenter', 'focusin'].forEach(function (ev) {
    document.addEventListener(ev, function (e) { var t = e.target; if (t && t.closest && t.closest('.js-drawer-open-nav')) load(); }, { capture: true, passive: true });
  });
  document.addEventListener('drawerOpen', load);
  function idle() { if ('requestIdleCallback' in window) requestIdleCallback(load, { timeout: 4000 }); else setTimeout(load, 2500); }
  if (document.readyState === 'complete') idle(); else window.addEventListener('load', idle);
})();
